import { Component, ContentChild, ElementRef, Input, OnInit, OnDestroy, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TabViewChangeEvent } from 'primeng/tabview';
import { Subject, Subscription } from 'rxjs';
import { RoutingService } from 'src/app/services/routing.service';
import { ScreenDimensionsService } from 'src/app/services/screen-dimensions.service';

@Component({
  selector: 'app-entity-page',
  templateUrl: './entity-page.component.html',
  styleUrl: './entity-page.component.scss'
})
export class EntityPageComponent implements OnInit, OnDestroy {
  @ContentChild('detailsContent') detailsContent!: TemplateRef<any>;
  @ContentChild('mapContent') mapContent!: TemplateRef<any>;
  @ContentChild('footer') footer!: TemplateRef<any>;
  
  @Input() closeClicked!: Subject<void>;
  @Input() detailsContentTitle :string |null =''
  @Input() mapContentTitle='';
  @Input() loading: boolean = false;
  @Input() switchToMapTab: Subject<void> = new Subject<void>();
  activeTab: 'details' | 'map' = 'details';
  activeTabIndex: number = 0;
  isSmallScreen = false;
  private entityDetailsSub?: Subscription;

  constructor( private screenDimensionsService: ScreenDimensionsService, private routingService: RoutingService, private translate: TranslateService ) {}

  ngOnInit() {
    this.screenDimensionsService.isSmallScreen$.subscribe(isSmallScreen => {
      this.isSmallScreen = isSmallScreen;
    });

    this.switchToMapTab.subscribe(() => {
      this.activeTab = 'map';
      this.activeTabIndex = 1;
    });
  }

  setActiveTab(tab: TabViewChangeEvent) {
    this.activeTab = tab.index === 0 ? 'details' : 'map';
  }

  onCloseEntityPage(): void {
    this.closeClicked.next();
    this.routingService.resetEntityDetails();
  }

  ngOnDestroy(): void {
    this.entityDetailsSub?.unsubscribe();
  }
}
